export type SpreadId = 'daily' | 'love' | 'work' | 'path' | 'yesno';

/** Which lens a card is read through. */
export type Theme = 'general' | 'love' | 'work';

export type PositionKey =
    | 'today'
    | 'you'
    | 'them'
    | 'bond'
    | 'guidance'
    | 'situation'
    | 'obstacle'
    | 'advice'
    | 'past'
    | 'present'
    | 'future'
    | 'answer';

export interface Position {
    key: PositionKey;
    /** What the card says in this position: its meaning, the advice, or both. */
    shows: 'meaning' | 'advice' | 'both';
}

export interface SpreadDef {
    id: SpreadId;
    theme: Theme;
    positions: Position[];
    /** Asks for a name before the ritual (the person the reading is about). */
    needsName: boolean;
}

export const SPREADS: Record<SpreadId, SpreadDef> = {
    daily: {
        id: 'daily',
        theme: 'general',
        needsName: false,
        positions: [{ key: 'today', shows: 'both' }],
    },
    love: {
        id: 'love',
        theme: 'love',
        needsName: true,
        positions: [
            { key: 'you', shows: 'meaning' },
            { key: 'them', shows: 'meaning' },
            { key: 'bond', shows: 'meaning' },
            { key: 'guidance', shows: 'advice' },
        ],
    },
    work: {
        id: 'work',
        theme: 'work',
        needsName: false,
        positions: [
            { key: 'situation', shows: 'meaning' },
            { key: 'obstacle', shows: 'meaning' },
            { key: 'advice', shows: 'advice' },
        ],
    },
    path: {
        id: 'path',
        theme: 'general',
        needsName: false,
        positions: [
            { key: 'past', shows: 'meaning' },
            { key: 'present', shows: 'meaning' },
            { key: 'future', shows: 'meaning' },
        ],
    },
    yesno: {
        id: 'yesno',
        theme: 'general',
        needsName: false,
        positions: [{ key: 'answer', shows: 'both' }],
    },
};

/** The spreads offered on the home screen, behind a video. The daily card has its own place. */
export const PAID_SPREADS: SpreadId[] = ['love', 'work', 'path', 'yesno'];
